import React from "react";
import { NavLink } from "react-router-dom";
import { Typography, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  navLink: {
    textDecoration: "none",
    color: theme.palette.text.primary,
    textAlign: "center",
    width: "100%",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 16px",
    borderRadius: "50px",
    width: "100%",
  },
  activeIconContainer: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
  },
  inactiveIconContainer: {
    backgroundColor: "transparent",
    color: theme.palette.text.secondary,
  },
  text: {
    marginTop: "4px",
    fontSize: "12px",
    lineHeight: "16px",
  },
  activeText: {
    color: theme.palette.text.primary,
    fontWeight: 600,
  },
  inactiveText: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
  }
}));

const SideNavItem = ({ to, icon, activeIcon, text }) => {
  const classes = useStyles();

  return (
    <NavLink to={to} className={classes.navLink}>
      {({ isActive }) => (
        <>
          <div className={clsx(classes.iconContainer, {
            [classes.activeIconContainer]: isActive,
            [classes.inactiveIconContainer]: !isActive,
          })}>
            {isActive ? activeIcon : icon}
          </div>
          <Typography
            className={clsx(classes.text, {
              [classes.activeText]: isActive,
              [classes.inactiveText]: !isActive,
            })}
          >
            {text}
          </Typography>
        </>
      )}
    </NavLink>
  );
};

SideNavItem.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  activeIcon: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
};

export default SideNavItem; 